<template>
  <div>
    <main-nav />

    <div class="site-wrapper">
      <!-- Content will be placed here -->
      <slot />
    </div>

    <div class="footer-wrapper bg-dark">
      <div class="footer-inner">
        <el-row :gutter="20">

          <el-col
            :xs="24"
            :sm="10"
            :md="8"
            :lg="8"
            :xl="8"
            class="contact-wrapper">
            <p class="no-margin-bottom">Ingalls Image, LLC.</p>
            <p class="no-margin-bottom"><span class="footer-icon icon-phone"/> | <a
              class="footer-link"
              href="tel:+16037818056">603.781.8056</a></p>
            <p class="no-margin-bottom"><span class="footer-icon icon-envelope"/> | <a
              class="footer-link"
              href="#"
              @click.prevent="toggleContactUs()">Contact-us@IngallsImage.com</a></p>
          </el-col>

          <el-col
            :xs="24"
            :sm="7"
            :md="8"
            :lg="8"
            :xl="8"
            class="location-wrapper">
            <p class="no-margin-bottom">29 Benton Road</p>
            <p class="no-margin-bottom">Hooksett NH, 03106</p>
          </el-col>

          <el-col
            :xs="24"
            :sm="7"
            :md="8"
            :lg="8"
            :xl="8"
            class="social-wrapper">
            <a
              href="https://www.facebook.com/IngallsImage"
              target="_blank"
              rel="noopener"><span class="icon-facebook"/></a>
              <!-- <a href="#"><span class="icon-linkedin"/></a> -->
            <a 
              href="https://twitter.com/IngallsImage"
              target="_blank"
              rel="noopener"><span class="icon-twitter"/></a>
          </el-col>

          <el-col
            :xs="24"
            class="copyright-wrapper">
            <p class="no-margin-bottom">© Copyright {{ new Date().getFullYear() }} Ingalls Image, LLC. All Rights
            Reserved.</p>
          </el-col>

        </el-row>
      </div>
    </div>
    <contact-us />
  </div>
</template>

<script>
/* ============
   * Default Layout
   * ============
   *
   * Used for the home and account pages.
   *
   * Layouts are used to store a lot of shared code.
   * This way the app stays clean.
   */
import ContactUs from '@/components/ContactUs.vue';
import MainNav from '@/components/MainNav.vue';

export default {
  /**
     * The name of the layout.
     */
  name: 'DefaultLayout',
  components: {
    ContactUs,
    MainNav,
  },

  /**
     * The data that can be used by the page.
     *
     * @returns {Object} The view-model data.
     */
  data() {
    return {
      menuCollapsed: false,
    };
  },

  /**
     * The methods that the layout can use.
     */
  methods: {
    toggleContactUs() {
      this.$store.dispatch('contactUs/toggle', true);
    },
  },
};
</script>
